import { useState, useEffect } from 'react';
import './newsdata.css';
import moment from "moment-jalaali";

export default function Newsdata() {
    const date = moment().format("jYYYY/jMM/jDD");
    const time = moment().format("HH:mm:ss");
    const [openaddnews, setOpenaddnews] = useState(false);
    const [newsList, setNewsList] = useState([]);
    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [timesend , setTimesend] = useState(`${time} - ${date}`)
    const [searchQuery, setSearchQuery] = useState('');
    const [editingId, setEditingId] = useState(null);
    useEffect(() => {
        fetch('http://185.164.73.170:5001/api/news')
            .then(res => res.json())
            .then(data => setNewsList(data));
    }, []);

    const addingNews = () => setOpenaddnews(!openaddnews);

    const handleSubmit = () => {
        const newNews = { title, text , timesend };
        const method = editingId ? 'PUT' : 'POST';
        const endpoint = editingId ? `http://185.164.73.170:5001/api/news/${editingId}` : 'http://185.164.73.170:5001/api/news';

        fetch(endpoint, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newNews),
        })
            .then(res => res.json())
            .then(data => {
                if (editingId) {
                    setNewsList(prevNews => prevNews.map(news => news.id === editingId ? data : news));
                } else {
                    setNewsList(prevNews => [...prevNews, data]);
                }
                setTitle('');
                setText('');
                setTimesend(`${time} - ${date}`)
                setEditingId(null);
                setOpenaddnews(false);
            });
    };

    const handleEdit = (id) => {
        const newsToEdit = newsList.find(news => news.id === id);
        if (newsToEdit) {
            setTitle(newsToEdit.title);
            setText(newsToEdit.text);
            setTimesend(newsToEdit.time);
            setEditingId(id);
            setOpenaddnews(true);
        }
    };

    const handleDelete = (id) => {
        fetch(`http://185.164.73.170:5001/api/news/${id}`, { method: 'DELETE' })
            .then(() => setNewsList(prevNews => prevNews.filter(news => news.id !== id)));
    };

    const filteredNews = newsList.filter(news =>
        news.title.includes(searchQuery) ||
        news.text.includes(searchQuery) ||
        news.time.includes(searchQuery) ||
        String(news.id).includes(searchQuery)
    );

    return (
        <div className='newsbox'>
            <button className='addnews' onClick={addingNews}>خبر جدید</button>
            <input
                className='searchnews'
                type='search'
                placeholder='جست و جو ...'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className='addnewsbox' style={{ display: openaddnews ? 'flex' : 'none' }}>
                <input
                    type='text'
                    placeholder='عنوان خبر'
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <textarea
                    type='text'
                    placeholder='متن خبر'
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                />
                <button onClick={handleSubmit}>{editingId ? 'ویرایش خبر' : 'ثبت خبر'}</button>
            </div>

            {/* نمایش کارت‌ها برای اخبار */}
            <div className="news-cards">
                {filteredNews.map(news => (
                    <div className="news-card" key={news.id}>
                        <div className="news-card-header">
                            <span className="idnews">آیدی: {news.id}</span>
                            <span className="titelnews">{news.title}</span>
                        </div>
                        <div className="news-card-content">{news.text}</div>
                        <div className="news-card-actions">
                            <button onClick={() => handleEdit(news.id)}>ویرایش</button>
                            <button onClick={() => handleDelete(news.id)}>حذف</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
